import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

import { ModalConfirmacionService } from '../../components/modal-confirmacion/modal-confirmacion.service';
import { AutenticacionService } from '../../seguridad/autenticacion.service';
import { SettingService } from '../../nucleo/configuracion/setting.service';
import { ChangePasswordService } from './change-password.service';
import { Constante } from '../../nucleo/constante/constante';
import { IUsuario } from '../../nucleo/interface/dto/IUsuario';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  public usuario: IUsuario;
  public mensaje: string;
  public tipoCambio: string;

  constructor(public settingService: SettingService, private router: Router,
    private loginService: AutenticacionService,
    private modalConfirmar: ModalConfirmacionService,
    private changePwdService: ChangePasswordService) {
    this.usuario = {
      usrLogin: '',
      password: '',
      passActual: '',
      passNueva: '',
      passConfi: ''
    }
  }

  ngOnInit() {
    if(this.changePwdService.parametro === undefined || this.changePwdService.parametro === ''){
      this.router.navigate(['/home']);
    }
  }

  changePassword(formulario: NgForm) {
    switch (this.changePwdService.parametro) {
      case '0':
        this.usuario.usrLogin = this.changePwdService.usuario;
        this.loginService.cambiarIniPass(this.usuario).subscribe(response => {
          if (response.codigo === Constante.RESPUESTA_OK) {
            this.loginService.borrarSessionStorage();
            this.modalConfirmar.mostrarModal(response.mensaje, Constante.TITULO_CHANGE_PASS).then(respose => {
              if (respose === true) {
                this.router.navigate(['/login']);
              }
            });
          } else {
            this.loginService.borrarSessionStorage();
            this.mensaje = response.mensaje;
          }
        }, (error: Error) => {
          console.log(error.message);
          this.mensaje = this.settingService.getMensaje('C0062');
        })
        break;
      case '1':
        this.modalConfirmar.mostrarModal(this.settingService.getMensaje('C0067'), Constante.TITULO_CHANGE_PASS).then(response => {
          if (response === true) {
            this.usuario.usrLogin = this.loginService.obtenerUsuario();
            this.loginService.cambiarPass(this.usuario).subscribe(response => {
              if (response.codigo === Constante.RESPUESTA_OK) {
                this.loginService.borrarSessionStorage();
                this.modalConfirmar.mostrarModal(response.mensaje, Constante.TITULO_CHANGE_PASS).then(respose => {
                  if (respose === true) {
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                this.loginService.borrarSessionStorage();
                this.mensaje = response.mensaje;
              }
            }, (error: Error) => {
              console.log(error.message);
              this.mensaje = this.settingService.getMensaje('C0062');
            })
          }
        })
        break;
      default:
        console.log("Tipo desconocido");
        break;
    }
    this.usuario.usrLogin = '';
    this.changePwdService.parametro = '';
  }

  regresar() {
    switch (this.changePwdService.parametro) {
      case '0':
        this.router.navigate(['/login']);
        break;
      case '1':
        this.router.navigate(['/home']);
        break;
      default:
        this.router.navigate(['/login']);
      break
    }
  }
}
